export const workOrderColumns = "1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1.2fr";
